<template>
	<div class="quad__block__child video">
		<img class="play" :src="play_button" alt="play" @click="modalOpen" />
		<img class="poster" :src="poster" alt="poster" />
		<div
			class="modal"
			:class="{ open: isModalOpen == true }"
			@click="modalClose"
		>
			<p class="close" @click="modalClose">Close <span>&times;</span></p>
			<div class="iframe__container">
				<iframe
					class="responsive__iframe"
					:src="sourceVideo"
					frameborder="0"
					allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
					allowfullscreen
				></iframe>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			isModalOpen: false,
			sourceVideo: '',
		};
	},

	props: {
		poster: {
			type: String,
			default: '',
		},
		play_button: {
			type: String,
			default: '',
		},
		source_video: {
			type: String,
			default: '',
		},
	},

	computed: {},

	watch: {},

	methods: {
		modalOpen() {
			this.sourceVideo = this.source_video;
			this.isModalOpen = true;
		},

		modalClose() {
			this.sourceVideo = '';
			this.isModalOpen = false;
		},
	},

	components: {},

	created() {},
	mounted() {},
};
</script>

<style lang="scss" scoped>
@import "../../styles/common/variables";

.video {
	background-color: #212121;
	min-width: 100px;
	min-height: 100px;
	padding: 0;
	display: flex;
	justify-content: center;
	align-items: center;
	overflow: hidden;

	&:hover {
		img.poster {
			transform: scale(1.1);
		}
	}

	img {
		&.poster {
			object-fit: cover;
			width: 100%;
			height: 100%;
			transition: 0.2s ease all;
			transform: scale(1);
		}

		&.play {
			height: 60px;
			position: absolute;
			z-index: 10;
			transition: 0.2s ease all;
			transform: scale(1);

			&:hover {
				transform: scale(1.1);
				cursor: pointer;
			}
		}
	}

	.modal {
		position: fixed;
		width: 100%;
		height: 100%;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		background: rgba(0, 0, 0, 0.9);
		opacity: 0;
		pointer-events: none;
		transition: 0.2s ease all;
		z-index: 999;
		display: grid;
		grid-template-columns: repeat(12, 1fr);
		grid-template-rows: repeat(3, 1fr);

		&.open {
			opacity: 1;
			pointer-events: all;
		}

		// iframe {
		//   grid-column: 3 / span 8;
		//   grid-row: 2 / span 1;
		// }

		.iframe__container {
			position: relative;
			overflow: hidden;
			width: 100%;
			padding-top: 56.25%; /* 16:9 Aspect Ratio (divide 9 by 16 = 0.5625) */
			grid-column: 3 / span 8;
			grid-row: 2 / span 1;
		}

		/* Then style the iframe to fit in the container div with full height and width */
		.responsive__iframe {
			position: absolute;
			top: 0;
			left: 0;
			bottom: 0;
			right: 0;
			width: 100%;
			height: 100%;
		}

		.close {
			position: absolute;
			top: 25px;
			left: 25px;
			color: white;
			font-weight: bold;
			margin: 0;
			transition: 0.2s ease all;
			display: flex;
			justify-content: center;
			align-items: center;
			padding-right: 1.5rem;

			span {
				font-size: 2rem;
				position: absolute;
				right: 0;
			}

			&:hover {
				color: $edc-red;
				cursor: pointer;
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// resources/assets/scripts/vue/VideoModal.vue